module.exports = __webpack_public_path__ + "static/media/black-camera.65ce5635.svg";